import { render, staticRenderFns } from "./DashboardContent.vue?vue&type=template&id=a4d512f0&lang=pug"
import script from "./DashboardContent.vue?vue&type=script&lang=js"
export * from "./DashboardContent.vue?vue&type=script&lang=js"
import style0 from "./DashboardContent.vue?vue&type=style&index=0&id=a4d512f0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports